import { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from 'reactstrap'

import ModalMensagens from '../../Interacao/ModalMensagens'
import { ConversaGetById } from '../../../Service/ApiService'
import { MsgSemRegistros } from '../../../Components'

import Item from './Item'

export default function ObjChart({ dataGrid }) {
  const [gridFilter, setGridFilter] = useState()
  const [modMensagens, setModMensagens] = useState({ show: false, messages: '' })

  async function onSelectItem(conversaId) {
    const response = await ConversaGetById(conversaId)
    setModMensagens({ show: true, messages: response.mensagens })
  }
  function onModMensagens() {
    setModMensagens({ show: false })
  }

  async function loadGridFilter() {
    if (dataGrid) {
      let _gridFilter = []
      for (let index = 0; index < dataGrid.length; index++) {
        if (dataGrid[index].cliNome) _gridFilter.push(dataGrid[index])

        if (_gridFilter.length == 10) break
      }
      setGridFilter(_gridFilter)
    } else setGridFilter()
  }

  useEffect(() => {
    loadGridFilter()
  }, [dataGrid])

  return (
    <>
      {modMensagens.show && <ModalMensagens change={onModMensagens} messages={modMensagens.messages} />}

      <Card className="main-card mb-2">
        <CardHeader>10 últimas Interações</CardHeader>
        <CardBody style={{ padding: '0' }}>
          {gridFilter ? (
            gridFilter.map((d, index) => <Item key={`top_${index}`} values={d} onSelect={onSelectItem} />)
          ) : (
            <Card className="main-card">
              <CardBody>
                <MsgSemRegistros />
              </CardBody>
            </Card>
          )}
        </CardBody>
      </Card>
    </>
  )
}
